module.exports = __webpack_public_path__ + "img/p@2x.46255969.jpg";